import Vue from 'vue';
import Router from 'vue-router';
import Index from "@/components/Indexnew";
import ModelService from '@/components/ModelService';
import DevelopService from '@/components/DevelopService';
import ApplyService from '@/components/ApplyService';
import CampanyInfo from '@/components/CampanyInfo';
import CampanyInfoNew from '@/components/CampanyInfoNew';
import VuePaginate from 'vue-paginate';
import 'lib-flexible';

Vue.use(Router);
Vue.use(VuePaginate);

export default new Router({
    mode: "history",
    routes: [
    {
      path: "/",
      name: "Index",
      component: Index
    },
    {
      path: "/cities",
      component: Index
    },
    {
      path: "/scenes",
      component: Index
    },
    {
      path: "/models",
      component: Index
    },
    {
        path: "/plugins",
        component: Index
    },
    {
      path: "/tools",
      component: Index
    },
    {
      path: "/videos",
      component: Index
    },
    {
      path: "/projects",
      component: Index
    },
    {
      path: "/topos",
      component: Index
    },
    {
      path: "/charts",
      component: Index
    },
    {
      path: "/dixs",
      component: Index
    },
    {
      path: "/senCharts",
      component: Index
    },
    {
        path: "/senEngines",
        component: Index
      },
    // 零代码
    {
        path: "/zeroCode",
        name: "application",
        component: Index,
        children:[
            // 项目
            {
                path: "*",
                name: "application",
                component: Index
            },
            // 项目
            {
              path: "getProjects",
              name: "application",
              component: Index
          },
            // 下载
            {
              path: "tools",
              name: "tools",
              component: Index
          },
          // 插件
          {
              path: "plugins",
              name: "plugin",
              component: Index
          },
          // 界面模板
          {
              path: "interfaceTemplate",
              name: "interfaceTemplate",
              component: Index
          },

          // 图层插件
          {
              path: "layerPlugin",
              name: "layerPlugin",
              component: Index
          },
          // 扩展插件
          {
              path: "extendPlugin",
              name: "extendPlugin",
              component: Index
          },
          // 核心插件
          {
              path: "corePlugin",
              name: "corePlugin",
              component: Index
          },
          // 孪生体面板
          {
              path: "twinsPanel",
              name: "twinsPanel",
              component: Index
          },
          // 操作原子
          {
              path: "operatingAtom",
              name: "operatingAtom",
              component: Index
          },
          // 业务插件
          {
              path: "businessPlugin",
              name: "businessPlugin",
              component: Index
          },
          // 场景控制插件
          {
              path: "sceneControlPlugin",
              name: "sceneControlPlugin",
              component: Index
          },
          // 配饰
          {
              path: "accessoriesPlugin",
              name: "accessoriesPlugin",
              component: Index
          },
          // 图表
          {
              path: "chartPlugin",
              name: "chartPlugin",
              component: Index
          },
          // 皮肤插件
          {
              path: "skinPlugin",
              name: "skinPlugin",
              component: Index
          },
          // 其他资源
          {
              path: "otherPlugin",
              name: "otherPlugin",
              component: Index
          }
        ]
    },
    {
      path: "/modelsever",
      name: "ModelService",
      component: ApplyService
    },
    {
      path: "/devsever",
      name: "DevService",
      component: DevelopService
    },
    {
      path: "/campanysever",
      name: "CampanyService",
      component: CampanyInfo
    },
    {
      path: "/addcampanysever",
      name: "AddCampanyService",
      component: CampanyInfoNew
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js